import Vue from 'vue'

// 引入VueRouter
import Router from 'vue-router'
import Layout from '@/components/index'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '',
    redirect: '/index',
    name: 'index',
  },
  {
    path: '/index',
    component: Layout,
    children: [
      {
        path: '/index',
        component: () => import('@/views/index/index'),
        name: 'Index',
      },
      {
        path: '/ranch',
        component: () => import('@/views/public/ranch'),
        name: 'Ranch',
      },
      {
        path: '/detail',
        component: () => import('@/views/public/detail'),
        name: 'Detail',
      },
      {
        path: '/manage',
        component: () => import('@/views/public/manage'),
        name: 'Manage',
      },
      {
        path: '/kitchen',
        component: () => import('@/views/public/food'),
        name: 'Kitchen',
      },
      {
        path: '/calf',
        component: () => import('@/views/public/calf'),
        name: 'Calf',
      },
      {
        path: '/slaughter',
        component: () => import('@/views/public/slaughter'),
        name: 'Slaughter',
      },
      {
        path: '/trace',
        component: () => import('@/views/public/trace'),
        name: 'Trace',
      },
      {
        path: '/device',
        component: () => import('@/views/public/device'),
        name: 'Device',
      },
      {
        path: '/index/news',
        component: () => import('@/views/subpage/newspage'),
        name: 'SubNews',
      },
      {
        path: '/trace/list',
        component: () => import('@/views/subpage/trace-list'),
        name: 'SubTraceList',
      },
      {
        path: '/manage/detail',
        component: () => import('@/views/subpage/manage-detail'),
        name: 'ManageDetail',
      },
      {
        path: '/trace/detail',
        component: () => import('@/views/subpage/trace-detail'),
        name: 'SubTraceDetail',
      },
      {
        path: '/calf/detail',
        component: () => import('@/views/subpage/calf-detail'),
        name: 'SubCalfDetail',
      },
      {
        path: '/calf/list',
        component: () => import('@/views/subpage/calf-list'),
        name: 'SubCalfList',
      },
      {
        path: '/manage/list',
        component: () => import('@/views/subpage/manage-list'),
        name: 'SubManageList',
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/login'),
    name: 'Login',
  },
  {
    path: '/register',
    component: () => import('@/views/login/register'),
    name: 'Rsegister',
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  { path: '*', redirect: '/404', hidden: true }
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
let routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', 
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
